import classnames from 'classnames';
import {
  CKBadge,
  CKBox,
  CKButton,
  CKCompanyLogo,
  CKIconBox,
  CKLayoutGrid,
  CKLayoutHorizontal,
} from 'clearkit';
import { Link } from 'react-router-dom';

import { routes } from '~/components/app/appMainRoutes';

import { CompanyType } from './types';

type companyCardProps = {
  company: CompanyType;
  onAddHubSpot: () => void;
};

export const CompanyCard = ({ onAddHubSpot, company }: companyCardProps) => {
  const dividerClasses = 'pt-4 border-t border-gray-200';
  const showAddToHubSpot = false;
  const hasTags = company.tags.length;

  return (
    <CKBox className="p-6">
      <CKLayoutGrid
        className="grow"
        gridTemplateRows={hasTags ? 'auto 1fr auto' : 'auto 1fr'}
      >
        <header className="space-y-4">
          <CKLayoutHorizontal justifyContent="center">
            <CKIconBox className="!p-0.5">
              <CKCompanyLogo domain={company.domain ?? ''} size={48} />
            </CKIconBox>
          </CKLayoutHorizontal>
          <div className="text-sm text-center">
            <h3 className="text-lg font-medium">{company.name}</h3>
            <h4>{company.domain}</h4>
          </div>
        </header>
        {hasTags ? (
          <CKLayoutHorizontal
            alignItems="start"
            className={classnames(dividerClasses, 'self-start')}
            gap=".5rem"
            justifyContent="center"
          >
            {company.tags.map((tag) => (
              <CKBadge key={tag}>
                <span className="min-w-0 truncate">{tag}</span>
              </CKBadge>
            ))}
          </CKLayoutHorizontal>
        ) : null}
        <CKLayoutHorizontal className={dividerClasses} justifyContent="center">
          {showAddToHubSpot ? (
            <CKButton
              onClick={onAddHubSpot}
              variant="simple"
              variantColor="blue"
            >
              Add to HubSpot
            </CKButton>
          ) : (
            <CKButton
              as={Link}
              to={`${routes.targetMarkets}/${company.domain}`}
              variant="simple"
              variantColor="blue"
            >
              View company
            </CKButton>
          )}
        </CKLayoutHorizontal>
      </CKLayoutGrid>
    </CKBox>
  );
};
